// ── V142: 발주서 수량은 단가표 '줄'마다 따로 ──────────────────────────────────
// 예전엔 발주 수량을 품목 이름으로 기억해서, 이름이 같은 품목(시장 계란 · 다른 발주처 계란)은
// 하나를 1판 담으면 둘 다 1판, 하나를 지우면 둘 다 지워졌다. 이제 코드·이름·발주처로 줄을 구별한다.
import { normalizeIngredientName } from './ingredientMatch';

const s = (x) => String(x == null ? '' : x).trim();

/** 단가표 한 줄의 발주 키 */
export function orderKeyOf(p) {
  if (!p) return '';
  return [s(p.code), s(p.name), s(p.vendor)].join('::');
}

/** 레시피·재고에서 넘어온 품목 이름 → 단가표 줄 (같은 이름이 여러 줄이면 원가 계산과 같은 첫 줄) */
export function findOrderRow(prices, name) {
  const list = prices || [];
  const n = s(name);
  if (!n) return undefined;
  const exact = list.find(p => p && s(p.name) === n);
  if (exact) return exact;
  const k = normalizeIngredientName(n);
  return list.find(p => p && normalizeIngredientName(p.name) === k);
}
